import {useEffect, useRef, useState} from "react";
import TableFunction from "../../../../components/table/TableFunction";
import {useDispatch} from "react-redux";
import {SearchByFilters, SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../components/table/Model/TableModel";

/**
 * Cards view of the roster of the guards, with the selfie of each guard.
 */
const GuardRosterCardsApp = (props) => {
    const {
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setIsAllChecked,
        searchElement,
        setBodyForExport,
        setCriteria,
        finalArray,
        option,
        view,
    } = props;

    const [results, setResults] = useState(null);
    const elementRef = useRef(null);
    const searchId = 'txt_grc_search_guards';

    // The cards panel takes the rest of the screen, so the pagination stays at the bottom
    useEffect(() => {
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [results]);

    const dispatch = useDispatch();

    // The rows are selected by the employee record of the guard, the one it is deleted with
    const setSearchResults = (data) => setResults(data ? {
        ...data,
        content: (data?.content || []).map((item) => ({...item, id: item.employeeId})),
    } : data);

    const getData = (page, {rowsPerPage}) => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model: option, key: searchElement, view});
        setBodyForExport(body);
        dispatch(SimpleSearch({body})).then(({payload: {data: {data, success}}}) => {
            if (success) setSearchResults(data);
        });
    };

    // The body is kept as the criteria, the header exports the advanced search with it
    const getDataAdvancedSearch = (page, {rowsPerPage}) => {
        const criteria = finalArray.map((item) => CRITERIA_MODEL.set(item));
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, criteria, view});
        setCriteria(body);
        dispatch(SearchByFilters({option, body})).then(({payload: {data: {data, success}}}) => {
            if (success) setSearchResults(data);
        });
    };

    const {
        t, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        view,
        labelRowsPerPage: 'guards_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        searchElement,
        getData,
        modified,
        setModified,
        getDataAdvancedSearch,
        finalArray,
    });

    return {
        t,
        searchId,
        elementRef,
        results,
        setSearchResults,
        rowsPerPage,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
    };
};

export default GuardRosterCardsApp;
